/** Texts for Privacy en gegevens, the support banner and the back office. */
export const adminNl = {
  'privacy.title': 'Privacy en gegevens',
  'privacy.intro': 'Jij bent eigenaar van de gegevens van je klanten. Wij bewaren en verwerken ze alleen voor jou, op servers in de EU.',
  'privacy.ownerOnly': 'Alleen de eigenaar kan hier iets aanpassen.',
  'privacy.dpa': 'Verwerkersovereenkomst',
  'privacy.dpaIntro': 'De afspraken tussen jou en ons over de gegevens van je klanten, zoals de AVG vraagt.',
  'privacy.dpaPoint1': 'Wij gebruiken de gegevens van je klanten alleen om de agenda, online boeken en berichten te laten werken. Nooit voor onszelf.',
  'privacy.dpaPoint2': 'De gegevens staan in de EU (Hetzner, Helsinki). E-mails gaan via onze e-maildienst.',
  'privacy.dpaPoint3': 'Ons team kijkt alleen mee als jij support-toegang aanzet, en je ziet hieronder wanneer.',
  'privacy.dpaPoint4': 'Je kunt al je gegevens altijd downloaden. Stop je, dan verwijderen we ze na 90 dagen.',
  'privacy.dpaAccepted': 'Geaccepteerd op {date} (versie {version}).',
  'privacy.dpaNew': 'Er is een nieuwe versie. Lees de punten hierboven en accepteer opnieuw.',
  'privacy.dpaNotYet': 'Nog niet geaccepteerd.',
  'privacy.dpaAccept': 'Ik ga akkoord',
  'privacy.support': 'Support-toegang',
  'privacy.supportIntro': 'Hulp nodig bij het instellen? Zet support-toegang aan, dan kan ons team in je salon meekijken en helpen. Het gaat vanzelf weer uit.',
  'privacy.supportOff': 'Uit. Ons team kan niet in je salon.',
  'privacy.supportOn': 'Aan tot {date}.',
  'privacy.supportFor': '{n} dagen',
  'privacy.supportDay': '1 dag',
  'privacy.supportStop': 'Zet uit',
  'privacy.supportNow': '{name} kijkt nu mee (tot {time}).',
  'privacy.supportLog': 'Geschiedenis',
  'privacy.log.support.allowed': 'Support-toegang aangezet',
  'privacy.log.support.revoked': 'Support-toegang uitgezet',
  'privacy.log.support.session_started': 'Meekijken gestart',
  'privacy.log.support.session_ended': 'Meekijken gestopt',
  'privacy.log.admin.trial_extended': 'Proefperiode verlengd',
  'privacy.log.admin.salon_created': 'Salon voor je klaargezet',
  'privacy.export': 'Al je gegevens',
  'privacy.exportIntro': 'Download alles wat je salon bij ons heeft: instellingen, diensten, team, klanten en afspraken, in één bestand (JSON). Handig als back-up of om over te stappen.',
  'privacy.exportButton': 'Download alles',
  'privacy.exportClients': 'Alleen je klantenlijst nodig? Die download je als Excel-bestand onder Klanten.',
  'support.banner': 'Je kijkt mee als support bij {salon}, tot {time}. Alles wat je doet wordt vastgelegd.',
  'support.end': 'Stoppen met meekijken',
  'admin.title': 'Beheer',
  'admin.intro': 'Alleen voor ons team. Alles wat je hier doet wordt bij de salon vastgelegd.',
  'admin.link': 'Beheer',
  'admin.health': 'Platform',
  'admin.h.salons': 'Salons',
  'admin.h.active': 'Actief (7 dagen)',
  'admin.h.bookings': 'Afspraken (24 uur)',
  'admin.h.online': 'Online geboekt (24 uur)',
  'admin.h.sent': 'Berichten verstuurd (24 uur)',
  'admin.h.failed': 'Mislukt (24 uur)',
  'admin.h.overdue': 'Te laat in de wachtrij',
  'admin.overdueHint': 'Berichten die al 10 minuten weg hadden moeten zijn. Draait de worker?',
  'admin.search': 'Zoek op salonnaam, link of e-mail van de eigenaar',
  'admin.none': 'Geen salons gevonden.',
  'admin.eyebrow': 'KoalaSpot · intern',
  'admin.back': 'Terug naar de app',
  'admin.attention': 'Let op',
  'admin.h.errors': 'Open fouten',
  'admin.errors': 'Fouten',
  'admin.errors.none': 'Geen open fouten. Nieuwe fouten komen hier en per e-mail binnen.',
  'admin.errors.resolve': 'Opgelost',
  'admin.errors.seen': '{n}× · laatst {date}',
  'admin.att.trialEnds': 'Proefperiode eindigt {date}',
  'admin.att.expired': 'Proefperiode verlopen',
  'admin.att.support': 'Support-toegang tot {date}',
  'admin.att.noOwner': 'Nog geen eigenaar ingelogd',
  'admin.att.none': 'Niets dat nu aandacht vraagt.',
  'admin.att.deletes': 'Afgelopen · gegevens worden verwijderd op {date}',
  'admin.att.pastDue': 'Betaling mislukt sinds {date}',
  'admin.att.suspended': 'Staat stil: niet betaald',
  'admin.status.paying': 'Betaalt · {n} agenda(\'s) · {interval}',
  'admin.billing.title': 'Betalingen',
  'admin.billing.intro': 'Abonnementen die we niet aan een salon konden koppelen. Koppel ze in Plug&Pay (zet de salon-id in de meta) of betaal terug, en markeer ze dan als afgehandeld.',
  'admin.billing.unmatched': 'Abonnement zonder salon',
  'admin.billing.duplicate': 'Tweede abonnement voor een salon',
  'admin.billing.done': 'Afgehandeld',
  'admin.col.salon': 'Salon',
  'admin.col.owner': 'Eigenaar',
  'admin.col.status': 'Status',
  'admin.col.activity': 'Laatste afspraak',
  'admin.col.bookings': 'Afspraken',
  'admin.status.trialing': 'Proef tot {date}',
  'admin.status.active': 'Actief',
  'admin.status.past_due': 'Betaling achter',
  'admin.status.expired': 'Verlopen',
  'admin.status.suspended': 'Staat stil',
  'admin.status.cancelled': 'Opgezegd',
  'admin.extend': '+7 dagen proef',
  'admin.comped.on': 'Gratis maken',
  'admin.comped.off': 'Niet meer gratis',
  'admin.comped.onHint': 'Gratis account: heeft nooit een abonnement nodig (onze test- en demosalons).',
  'admin.comped.offHint': 'Daarna geldt de proefperiode weer; is die voorbij, dan sluit de boekingspagina.',
  'admin.status.comped': 'Gratis',
  'admin.open': 'Meekijken',
  'admin.noConsent': 'Geen support-toegang',
  'admin.noOwner': 'nog niemand',
  'admin.invited': 'uitgenodigd: {email}',
  'admin.create': 'Salon klaarzetten voor een klant',
  'admin.createIntro': 'De eigenaar krijgt een uitnodiging per e-mail. Ons team houdt 14 dagen support-toegang om alles in te richten.',
  'admin.createSalon': 'Naam van de salon',
  'admin.createType': 'Soort salon',
  'admin.createOwner': 'Naam van de eigenaar',
  'admin.createEmail': 'E-mail van de eigenaar',
  'admin.createSubmit': 'Klaarzetten en uitnodigen',
  'admin.created': 'Klaargezet. De uitnodiging is verstuurd.',
};

export const adminEn: Record<keyof typeof adminNl, string> = {
  'privacy.title': 'Privacy and data',
  'privacy.intro': 'You own your clients’ data. We only store and process it for you, on servers in the EU.',
  'privacy.ownerOnly': 'Only the owner can change things here.',
  'privacy.dpa': 'Processing agreement',
  'privacy.dpaIntro': 'The agreement between you and us about your clients’ data, as the GDPR requires.',
  'privacy.dpaPoint1': 'We only use your clients’ data to run the calendar, online booking and messages. Never for ourselves.',
  'privacy.dpaPoint2': 'The data is stored in the EU (Hetzner, Helsinki). Emails go through our email service.',
  'privacy.dpaPoint3': 'Our team only looks in when you switch on support access, and you see below when.',
  'privacy.dpaPoint4': 'You can always download all your data. If you leave, we delete it after 90 days.',
  'privacy.dpaAccepted': 'Accepted on {date} (version {version}).',
  'privacy.dpaNew': 'There is a new version. Read the points above and accept again.',
  'privacy.dpaNotYet': 'Not accepted yet.',
  'privacy.dpaAccept': 'I agree',
  'privacy.support': 'Support access',
  'privacy.supportIntro': 'Need help setting up? Switch on support access so our team can look in and help. It switches off by itself.',
  'privacy.supportOff': 'Off. Our team can’t get into your salon.',
  'privacy.supportOn': 'On until {date}.',
  'privacy.supportFor': '{n} days',
  'privacy.supportDay': '1 day',
  'privacy.supportStop': 'Switch off',
  'privacy.supportNow': '{name} is looking in now (until {time}).',
  'privacy.supportLog': 'History',
  'privacy.log.support.allowed': 'Support access switched on',
  'privacy.log.support.revoked': 'Support access switched off',
  'privacy.log.support.session_started': 'Started looking in',
  'privacy.log.support.session_ended': 'Stopped looking in',
  'privacy.log.admin.trial_extended': 'Trial extended',
  'privacy.log.admin.salon_created': 'Salon set up for you',
  'privacy.export': 'All your data',
  'privacy.exportIntro': 'Download everything your salon has with us: settings, services, team, clients and appointments, in one file (JSON). Useful as a backup or to move elsewhere.',
  'privacy.exportButton': 'Download everything',
  'privacy.exportClients': 'Only need your client list? Download it as an Excel file under Clients.',
  'support.banner': 'You are looking in as support at {salon}, until {time}. Everything you do is logged.',
  'support.end': 'Stop looking in',
  'admin.title': 'Back office',
  'admin.intro': 'For our team only. Everything you do here is logged on the salon.',
  'admin.link': 'Back office',
  'admin.health': 'Platform',
  'admin.h.salons': 'Salons',
  'admin.h.active': 'Active (7 days)',
  'admin.h.bookings': 'Appointments (24 h)',
  'admin.h.online': 'Booked online (24 h)',
  'admin.h.sent': 'Messages sent (24 h)',
  'admin.h.failed': 'Failed (24 h)',
  'admin.h.overdue': 'Overdue in the queue',
  'admin.overdueHint': 'Messages that should have gone out 10 minutes ago. Is the worker running?',
  'admin.search': 'Search by salon name, link or owner email',
  'admin.none': 'No salons found.',
  'admin.eyebrow': 'KoalaSpot · internal',
  'admin.back': 'Back to the app',
  'admin.attention': 'Needs attention',
  'admin.h.errors': 'Open errors',
  'admin.errors': 'Errors',
  'admin.errors.none': 'No open errors. New ones show up here and by email.',
  'admin.errors.resolve': 'Solved',
  'admin.errors.seen': '{n}× · last {date}',
  'admin.att.trialEnds': 'Trial ends {date}',
  'admin.att.expired': 'Trial expired',
  'admin.att.support': 'Support access until {date}',
  'admin.att.noOwner': 'No owner has logged in yet',
  'admin.att.none': 'Nothing needs attention right now.',
  'admin.att.deletes': 'Ended · data deleted on {date}',
  'admin.att.pastDue': 'Payment failed since {date}',
  'admin.att.suspended': 'On hold: unpaid',
  'admin.status.paying': 'Paying · {n} agenda(s) · {interval}',
  'admin.billing.title': 'Payments',
  'admin.billing.intro': "Subscriptions we couldn't link to a salon. Link them in Plug&Pay (put the salon id in the meta) or refund, then mark them as handled.",
  'admin.billing.unmatched': 'Subscription without a salon',
  'admin.billing.duplicate': 'Second subscription for a salon',
  'admin.billing.done': 'Handled',
  'admin.col.salon': 'Salon',
  'admin.col.owner': 'Owner',
  'admin.col.status': 'Status',
  'admin.col.activity': 'Last appointment',
  'admin.col.bookings': 'Appointments',
  'admin.status.trialing': 'Trial until {date}',
  'admin.status.active': 'Active',
  'admin.status.past_due': 'Payment overdue',
  'admin.status.expired': 'Expired',
  'admin.status.suspended': 'Suspended',
  'admin.status.cancelled': 'Cancelled',
  'admin.extend': '+7 days trial',
  'admin.comped.on': 'Make free',
  'admin.comped.off': 'No longer free',
  'admin.comped.onHint': 'Free account: never needs a subscription (our test and demo salons).',
  'admin.comped.offHint': 'The trial applies again; if it is over, the booking page closes.',
  'admin.status.comped': 'Free',
  'admin.open': 'Look in',
  'admin.noConsent': 'No support access',
  'admin.noOwner': 'nobody yet',
  'admin.invited': 'invited: {email}',
  'admin.create': 'Set up a salon for a customer',
  'admin.createIntro': 'The owner gets an email invitation. Our team keeps support access for 14 days to set everything up.',
  'admin.createSalon': 'Salon name',
  'admin.createType': 'Type of salon',
  'admin.createOwner': 'Owner’s name',
  'admin.createEmail': 'Owner’s email',
  'admin.createSubmit': 'Set up and invite',
  'admin.created': 'Done. The invitation has been sent.',
};
